__turbopack_context__.v({
  "vertical_offset": "WatchVideoButton-module-scss-module__imCtkW__vertical_offset",
  "watch_video_button": "WatchVideoButton-module-scss-module__imCtkW__watch_video_button",
  "watch_video_button_icon": "WatchVideoButton-module-scss-module__imCtkW__watch_video_button_icon",
  "watch_video_button_text": "WatchVideoButton-module-scss-module__imCtkW__watch_video_button_text",
});
